export function isAbsoluteUrl(url) {
  return /^https?:\/\//i.test(url ?? '');
}

export default function resolveTokkoBrokerUrl(url) {
  if (!url) {
    return '';
  }

  if (isAbsoluteUrl(url)) {
    return url;
  }

  return `${localStorage.getItem('tokkoBrokerHost') || ''}${url}`;
}
